import { lazy, Suspense, useEffect, useState } from "react";
import { RenderAnimationProps, Router } from "easy-page-router/react";

import { Loading } from "./components";
import { getLang } from "./services/lang";

import Index from "./pages/Index";
import Donate from "./pages/Donate";
import NotFound from "./pages/NotFound";
import ForgottenPassword from "./pages/ForgottenPassword";

import CountdownBoard from "./pages/countdown/Board";
import CountdownForm from "./pages/countdown/Form";
import Countdown from "./pages/countdown/Countdown";
import Timer from "./pages/countdown/Timer";

import PollBoard from "./pages/poll/Board";
import PollForm from "./pages/poll/Form";
import Poll from "./pages/poll/Poll";

import WhoBoard from "./pages/who/Board";
import WhoForm from "./pages/who/Form";
import Who from "./pages/who/Who";

import WhenBoard from "./pages/when/Board";
import WhenForm from "./pages/when/Form";
import When from "./pages/when/When";

import TeamBoard from "./pages/team/Board";
import TeamPage from "./pages/team/Team";

const Admin = lazy(() => import("./pages/admin/Admin"));

export default function TSORouter() {
    return <Router
        renderAnimation={Animation}
        renderPage={({ path }) => {
            const { dict } = getLang(path);

            if (path.length === 0 || path[0] === dict.url) return <Index />;

            if (path[0] === dict.urlDonate) return <Donate />;

            if (path[0] === dict.urlCountdown && !path[1]) return <CountdownBoard />;
            if (path[0] === dict.urlCountdown && path[1] === dict.urlNew) return <CountdownForm />;
            if (path[0] === dict.urlCountdown && path[1]) return <Countdown id={path[1]} />;
            if (path[0] === dict.urlTimer) return <Timer />;

            if (path[0] === dict.urlPoll && !path[1]) return <PollBoard />;
            if (path[0] === dict.urlPoll && path[1] === dict.urlNew) return <PollForm />;
            if (path[0] === dict.urlPoll && path[1]) return <Poll id={path[1]} />;

            if (path[0] === dict.urlWho && !path[1]) return <WhoBoard />;
            if (path[0] === dict.urlWho && path[1] === dict.urlNew) return <WhoForm />;
            if (path[0] === dict.urlWho && path[1]) return <Who id={path[1]} />;

            if (path[0] === dict.urlWhen && !path[1]) return <WhenBoard />;
            if (path[0] === dict.urlWhen && path[1] === dict.urlNew) return <WhenForm />;
            if (path[0] === dict.urlWhen && path[1]) return <When id={path[1]} />;

            if (path[0] === dict.urlTeam && !path[1]) return <TeamBoard />;
            if (path[0] === dict.urlTeam && path[1]) return <TeamPage teamId={path[1]} />;

            if (path[0] === dict.urlForgottenPassword && path[1]) return <ForgottenPassword token={path[1]} />;

            if (path[0] === "admin") return <Suspense fallback={<Loading />}>
                <Admin />
            </Suspense>;

            return <NotFound />;
        }}
    />;
}

function Animation({ page, state }: RenderAnimationProps) {
    const [newClass, setNewClass] = useState("new");
    const [hide, setHide] = useState(false);

    useEffect(() => {
        if (state === "active") {
            setHide(false);
        } else {
            setNewClass("");
            setTimeout(() => setHide(true), 500);
        }
    }, [state]);

    return <div className={`page ${state} ${newClass} ${hide ? "hide" : ""}`}>{page}</div>;
}
